'use strict';

var _taggedTemplateLiteral = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  cursor: pointer;\n  right: 20px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  height: 100%;\n  width: 100%;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: fixed;\n  color: ", ";\n  background: white;\n  padding: 20px 45px;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  height: 700px;\n  width: 530px;\n\n  .ant-btn {\n    color: ", ";\n    \n  }\n  .fa-download {\n    height: 12px;\n    width: 12;\n    color: ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  margin: auto;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 10;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _mediaTemplates = require('../../styled/mediaTemplates');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Popup = _styledComponents2.default.div(_templateObject());

var PopupInner = _styledComponents2.default.div(_templateObject2(), function (props) {
  return props.theme.platformPrimary;
}, function (props) {
  return props.theme.platformPrimary;
}, function (props) {
  return props.theme.platformPrimary;
});

var Icon = _styledComponents2.default.div(_templateObject3());

var CloseBtnWrapper = _styledComponents2.default.div(_templateObject4());

exports.default = {
  Popup: Popup,
  PopupInner: PopupInner,
  Icon: Icon,
  CloseBtnWrapper: CloseBtnWrapper
};